<template>
    <span v-if="value != null && max != null && max > 0" class="star-rating d-inline-flex align-items-center">
        <span class="stars me-1">
            <i v-for="i in 5" :key="i" :class="starClass(i)"></i>
        </span>
        <span :class="textClass">{{ value.toFixed(2) }}<span class="text-muted">/{{ max }}</span></span>
    </span>
    <span v-else class="text-muted">-</span>
</template>
<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Prop } from '@/helpers/Decorators';

@Options({})
export default class StarRating extends Vue
{
    @Prop({ type: Number, default: null }) public value!: number | null;
    @Prop({ type: Number, default: null }) public max!: number | null;

    // Normalize value to a 0-5 star fill so Booking (0-10) and Airbnb (1-5) share
    // the same 5-star visual. Numeric label next to the stars still shows the
    // native value + max so it's never misread.
    public get fivePoint(): number
    {
        if (this.value == null || this.max == null || this.max <= 0) return 0;
        return Math.max(0, Math.min(5, (this.value / this.max) * 5));
    }

    public starClass(starIndex: number): string
    {
        // Each star (1..5) shows full / half / empty based on the 5-point value.
        const v = this.fivePoint;
        if (v >= starIndex) return 'fas fa-star text-warning';
        if (v >= starIndex - 0.5) return 'fas fa-star-half-alt text-warning';
        return 'far fa-star text-muted';
    }

    public get textClass(): string
    {
        if (this.value == null || this.max == null) return '';
        const ratio = this.value / this.max;
        if (ratio >= 0.8) return 'text-success fw-bold';
        if (ratio >= 0.6) return 'text-warning fw-bold';
        return 'text-danger fw-bold';
    }
}
</script>
<style scoped>
.star-rating .stars i { font-size: 0.85em; margin-right: 1px; }
</style>
